export const VALID_CVSS_PREFIXES = [
  "CVSS:2.0",
  "CVSS:3.0",
  "CVSS:3.1",
  "CVSS:4.0",
];

export const CVSS2_VECTOR_REGEX =
  /CVSS:2\.0\/(AV:(N|A|L)\/AC:(L|M|H)\/Au:(N|S|M)\/C:(N|P|C)\/I:(N|P|C)\/A:(N|P|C))$/m;
export const CVSS3_0_VECTOR_REGEX =
  /CVSS:3\.0\/((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))((A:[A-Z]\/)|(AC:[A-Z]\/)|(I:[A-Z]\/)|(C:[A-Z]\/)|(S:[A-Z]\/)|(PR:[A-Z]\/)|(UI:[A-Z]\/)|(AV:[A-Z]\/))(A:[A-Z]|AC:[A-Z]|I:[A-Z]|C:[A-Z]|S:[A-Z]|PR:[A-Z]|UI:[A-Z]|AV:[A-Z])$/m;

export const CVSS3_1_VECTOR_REGEX =
  /^CVSS:3\.1\/((([A-Z]{1,3}:[A-Z])\/)*([A-Z]{1,3}:[A-Z]))$/;
export const CVSS4_VECTOR_REGEX =
  /CVSS:4\.0\/(AV:[A-Z]\/AC:[A-Z]\/AT:[A-Z]\/PR:[A-Z]\/UI:[A-Z]\/VC:[A-Z]\/VI:[A-Z]\/VA:[A-Z]\/SC:[A-Z]\/SI:[A-Z]\/SA:[A-Z](\/.*)?)$/m;

const CVSS_HIGH = { label: "High (H)", value: "H" };
const CVSS_LOW = { label: "Low (L)", value: "L" };
const CVSS_NONE = { label: "None (N)", value: "N" };
const CVSS_REQUIRED = { label: "Required (R)", value: "R" };

export const NOT_DEFINED_OPTION = { label: "Not Defined", value: "X" };

export const CVSS_OPTIONS = {
  ATTACK_VECTOR: [
    { label: "Network (N)", value: "N" },
    { label: "Adjacent (A)", value: "A" },
    { label: "Local (L)", value: "L" },
    { label: "Physical (P)", value: "P" },
  ],
  ACCESS_VECTOR: [
    { label: "Network (N)", value: "N" },
    { label: "Adjacent (A)", value: "A" },
    { label: "Local (L)", value: "L" },
  ],
  ACCESS_COMPLEXITY: [CVSS_HIGH, { label: "Medium (M)", value: "M" }, CVSS_LOW],
  AUTHENTICATION: [
    { label: "None (N)", value: "N" },
    { label: "Single (S)", value: "S" },
    { label: "Multiple (M)", value: "M" }, // For CVSS version 2.0
  ],
  SCOPE: [
    { label: "Unchanged (U)", value: "U" },
    { label: "Changed (C)", value: "C" },
  ],
  ATTACK_COMPLEXITY: [CVSS_LOW, CVSS_HIGH],
  CONFIDENTIALITY_IMPACT: [
    { label: "None (N)", value: "N" },
    { label: "Partial (P)", value: "P" },
    { label: "Complete (C)", value: "C" },
  ],
  INTEGRITY_IMPACT: [
    { label: "None (N)", value: "N" },
    { label: "Partial (P)", value: "P" },
    { label: "Complete (C)", value: "C" },
  ],
  AVAILABILITY_IMPACT: [
    { label: "None (N)", value: "N" },
    { label: "Partial (P)", value: "P" },
    { label: "Complete (C)", value: "C" },
  ],
  USER_INTERACTION: [CVSS_NONE, CVSS_REQUIRED],
  ATTACK_REQUIREMENTS: [
    { label: "None (N)", value: "N" },
    { label: "Present (P)", value: "P" },
  ],
  PRIVILEGES_REQUIRED: [CVSS_NONE, CVSS_LOW, CVSS_HIGH],
  USER_INTERACTIONV4: [
    { label: "None (N)", value: "N" },
    { label: "Passive (P)", value: "P" },
    { label: "Active (A)", value: "A" },
  ],
  COMMON: [CVSS_NONE, CVSS_LOW, CVSS_HIGH],
  EXPLOIT_CODE_MATURITY: [
    { label: "Unproven (U)", value: "U" },
    { label: "Proof (P)", value: "P" },
    { label: "Functional (F)", value: "F" },
    { label: "High (H)", value: "H" },
  ],
  REMEDIATION_LEVEL: [
    { label: "Official (O)", value: "O" },
    { label: "Temp. (T)", value: "T" },
    { label: "Workaround (W)", value: "W" },
    { label: "Unavailable (U)", value: "U" },
  ],
  REPORT_CONFIDENCE: [
    { label: "Unknown (U)", value: "U" },
    { label: "Reasonable (R)", value: "R" },
    { label: "Confirmed (C)", value: "C" },
  ],
  IMPACT_SUBSCORE: [CVSS_LOW, { label: "Medium (M)", value: "M" }, CVSS_HIGH],
};

export const CVSS_FIELDS = {
  "2.0": [
    {
      name: "AV20",
      label: "Access Vector (AV)",
      options: CVSS_OPTIONS.ACCESS_VECTOR,
      colSpan: 14,
    },
    {
      name: "AC20",
      label: "Access Complexity (AC)",
      options: CVSS_OPTIONS.ACCESS_COMPLEXITY,
      colSpan: 10,
    },
    {
      name: "Au20",
      label: "Authentication (Au)",
      options: CVSS_OPTIONS.AUTHENTICATION,
      colSpan: 14,
    },
    {
      name: "C20",
      label: "Confidentiality Impact (C)",
      options: CVSS_OPTIONS.CONFIDENTIALITY_IMPACT,
      colSpan: 10,
    },
    {
      name: "I20",
      label: "Integrity Impact (I)",
      options: CVSS_OPTIONS.INTEGRITY_IMPACT,
      colSpan: 14,
    },
    {
      name: "A20",
      label: "Availability Impact (A)",
      options: CVSS_OPTIONS.AVAILABILITY_IMPACT,
      colSpan: 10,
    },
  ],
  "3.0": [
    {
      name: "AV30",
      label: "Attack Vector (AV)",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
    },
    {
      name: "S30",
      label: "Scope (S)",
      options: CVSS_OPTIONS.SCOPE,
      colSpan: 10,
    },
    {
      name: "AC30",
      label: "Attack Complexity (AC)",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 14,
    },
    {
      name: "C30",
      label: "Confidentiality (C)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
    {
      name: "PR30",
      label: "Privileges Required (PR)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
    },
    {
      name: "I30",
      label: "Integrity (I)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
    {
      name: "UI30",
      label: "User Interaction (UI)",
      options: CVSS_OPTIONS.USER_INTERACTION,
      colSpan: 14,
    },
    {
      name: "A30",
      label: "Availability (A)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
  ],
  "3.1": [
    {
      name: "AV31",
      label: "Attack Vector (AV)",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
    },
    {
      name: "S31",
      label: "Scope (S)",
      options: CVSS_OPTIONS.SCOPE,
      colSpan: 10,
    },
    {
      name: "AC31",
      label: "Attack Complexity (AC)",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 14,
    },
    {
      name: "C31",
      label: "Confidentiality (C)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
    {
      name: "PR31",
      label: "Privileges Required (PR)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
    },
    {
      name: "I31",
      label: "Integrity (I)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
    {
      name: "UI31",
      label: "User Interaction (UI)",
      options: CVSS_OPTIONS.USER_INTERACTION,
      colSpan: 14,
    },
    {
      name: "A31",
      label: "Availability (A)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
  ],
  "4.0": [
    {
      name: "AV40",
      label: "Attack Vector (AV)",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
      group: "Exploitability Metrics",
    },
    {
      name: "AC40",
      label: "Attack Complexity (AC)",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 10,
      group: "Exploitability Metrics",
    },
    {
      name: "AT40",
      label: "Attack Requirements (AT)",
      options: CVSS_OPTIONS.ATTACK_REQUIREMENTS,
      colSpan: 14,
      group: "Exploitability Metrics",
    },
    {
      name: "PR40",
      label: "Privileges Required (PR)",
      options: CVSS_OPTIONS.PRIVILEGES_REQUIRED,
      colSpan: 10,
      group: "Exploitability Metrics",
    },
    {
      name: "UI40",
      label: "User Interaction (UI)",
      options: CVSS_OPTIONS.USER_INTERACTIONV4,
      colSpan: 14,
      group: "Exploitability Metrics",
    },
    {
      name: "VC40",
      label: "Confidentiality (VC)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      group: "Vulnerable System Impact Metrics",
    },
    {
      name: "VI40",
      label: "Integrity (VI)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      group: "Vulnerable System Impact Metrics",
    },
    {
      name: "VA40",
      label: "Availability (VA)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      group: "Vulnerable System Impact Metrics",
    },
    {
      name: "SC40",
      label: "Confidentiality (SC)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      group: "Subsequent System Impact Metrics",
    },
    {
      name: "SI40",
      label: "Integrity (SI)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      group: "Subsequent System Impact Metrics",
    },
    {
      name: "SA40",
      label: "Availability (SA)",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      group: "Subsequent System Impact Metrics",
    },
  ],
};

export const CVSS_MODIFIER_FIELDS = {
  "3.1": [
    {
      name: "MAV",
      label: "Attack Vector",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MAC",
      label: "Attack Complexity",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MPR",
      label: "Privileges Required",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MUI",
      label: "User Interaction",
      options: CVSS_OPTIONS.USER_INTERACTION,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MS",
      label: "Scope",
      options: CVSS_OPTIONS.SCOPE,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MC",
      label: "Confidentiality",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Impact Metrics",
    },
    {
      name: "MI",
      label: "Integrity",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Impact Metrics",
    },
    {
      name: "MA",
      label: "Availability",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Impact Metrics",
    },
    {
      name: "CR",
      label: "Confidentiality Requirement",
      options: CVSS_OPTIONS.IMPACT_SUBSCORE,
      colSpan: 10,
      secondary: true,
      category: "Environmental Score Metrics",
      subCategory: "Impact Subscore Modifiers",
    },
    {
      name: "IR",
      label: "Integrity Requirement",
      options: CVSS_OPTIONS.IMPACT_SUBSCORE,
      colSpan: 10,
      secondary: true,
      category: "Environmental Score Metrics",
      subCategory: "Impact Subscore Modifiers",
    },
    {
      name: "AR",
      label: "Availability Requirement",
      options: CVSS_OPTIONS.IMPACT_SUBSCORE,
      colSpan: 10,
      secondary: true,
      category: "Environmental Score Metrics",
      subCategory: "Impact Subscore Modifiers",
    },
  ],
};

export const CVSS_FIELDS_NEW_UI = {
  "2.0": [
    {
      name: "AV20",
      label: "Access Vector",
      options: CVSS_OPTIONS.ACCESS_VECTOR,
      colSpan: 14,
    },
    {
      name: "AC20",
      label: "Access Complexity",
      options: CVSS_OPTIONS.ACCESS_COMPLEXITY,
      colSpan: 10,
    },
    {
      name: "Au20",
      label: "Authentication",
      options: CVSS_OPTIONS.AUTHENTICATION,
      colSpan: 14,
    },
    {
      name: "C20",
      label: "Confidentiality Impact",
      options: CVSS_OPTIONS.CONFIDENTIALITY_IMPACT,
      colSpan: 10,
    },
    {
      name: "I20",
      label: "Integrity Impact",
      options: CVSS_OPTIONS.INTEGRITY_IMPACT,
      colSpan: 14,
    },
    {
      name: "A20",
      label: "Availability Impact",
      options: CVSS_OPTIONS.AVAILABILITY_IMPACT,
      colSpan: 10,
    },
  ],
  "3.0": [
    {
      name: "AV30",
      label: "Attack Vector",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
    },
    {
      name: "S30",
      label: "Scope",
      options: CVSS_OPTIONS.SCOPE,
      colSpan: 10,
    },
    {
      name: "AC30",
      label: "Attack Complexity",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 14,
    },
    {
      name: "C30",
      label: "Confidentiality",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
    {
      name: "PR30",
      label: "Privileges Required",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
    },
    {
      name: "I30",
      label: "Integrity",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
    {
      name: "UI30",
      label: "User Interaction",
      options: CVSS_OPTIONS.USER_INTERACTION,
      colSpan: 14,
    },
    {
      name: "A30",
      label: "Availability",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
    },
  ],
  "3.1": [
    {
      name: "MAV",
      label: "Attack Vector",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MAC",
      label: "Attack Complexity",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MPR",
      label: "Privileges Required",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MUI",
      label: "User Interaction",
      options: CVSS_OPTIONS.USER_INTERACTION,
      colSpan: 14,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MS",
      label: "Scope",
      options: CVSS_OPTIONS.SCOPE,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Exploitability Metrics",
    },
    {
      name: "MC",
      label: "Confidentiality",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Impact Metrics",
    },
    {
      name: "MI",
      label: "Integrity",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Impact Metrics",
    },
    {
      name: "MA",
      label: "Availability",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      category: "Environmental Score Metrics",
      subCategory: "Impact Metrics",
    },
    {
      name: "CR",
      label: "Confidentiality Requirement",
      options: CVSS_OPTIONS.IMPACT_SUBSCORE,
      colSpan: 10,
      secondary: true,
      category: "Environmental Score Metrics",
      subCategory: "Impact Subscore Modifiers",
    },
    {
      name: "IR",
      label: "Integrity Requirement",
      options: CVSS_OPTIONS.IMPACT_SUBSCORE,
      colSpan: 10,
      secondary: true,
      category: "Environmental Score Metrics",
      subCategory: "Impact Subscore Modifiers",
    },
    {
      name: "AR",
      label: "Availability Requirement",
      options: CVSS_OPTIONS.IMPACT_SUBSCORE,
      colSpan: 10,
      secondary: true,
      category: "Environmental Score Metrics",
      subCategory: "Impact Subscore Modifiers",
    },
    {
      name: "E",
      label: "Exploit Code Maturity",
      options: CVSS_OPTIONS.EXPLOIT_CODE_MATURITY,
      colSpan: 10,
      secondary: true,
      category: "Temporal Score Metrics",
      subCategory: "",
    },
    {
      name: "RL",
      label: "Remediation Level",
      options: CVSS_OPTIONS.REMEDIATION_LEVEL,
      colSpan: 10,
      secondary: true,
      category: "Temporal Score Metrics",
      subCategory: "",
    },
    {
      name: "RC",
      label: "Report Confidence",
      options: CVSS_OPTIONS.REPORT_CONFIDENCE,
      colSpan: 10,
      secondary: true,
      category: "Temporal Score Metrics",
      subCategory: "",
    },
  ],
  "4.0": [
    {
      name: "AV40",
      label: "Attack Vector",
      options: CVSS_OPTIONS.ATTACK_VECTOR,
      colSpan: 14,
      group: "Exploitability Metrics",
    },
    {
      name: "AC40",
      label: "Attack Complexity",
      options: CVSS_OPTIONS.ATTACK_COMPLEXITY,
      colSpan: 10,
      group: "Exploitability Metrics",
    },
    {
      name: "AT40",
      label: "Attack Requirements",
      options: CVSS_OPTIONS.ATTACK_REQUIREMENTS,
      colSpan: 14,
      group: "Exploitability Metrics",
    },
    {
      name: "PR40",
      label: "Privileges Required",
      options: CVSS_OPTIONS.PRIVILEGES_REQUIRED,
      colSpan: 10,
      group: "Exploitability Metrics",
    },
    {
      name: "UI40",
      label: "User Interaction",
      options: CVSS_OPTIONS.USER_INTERACTIONV4,
      colSpan: 14,
      group: "Exploitability Metrics",
    },
    {
      name: "VC40",
      label: "Confidentiality",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      group: "Vulnerable System Impact Metrics",
    },
    {
      name: "VI40",
      label: "Integrity",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      group: "Vulnerable System Impact Metrics",
    },
    {
      name: "VA40",
      label: "Availability",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      group: "Vulnerable System Impact Metrics",
    },
    {
      name: "SC40",
      label: "Confidentiality",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      group: "Subsequent System Impact Metrics",
    },
    {
      name: "SI40",
      label: "Integrity",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 10,
      group: "Subsequent System Impact Metrics",
    },
    {
      name: "SA40",
      label: "Availability",
      options: CVSS_OPTIONS.COMMON,
      colSpan: 14,
      group: "Subsequent System Impact Metrics",
    },
  ],
};
